import { CspProfile } from '@/types/user';
import {
  globalGetService,
  globalPostService,
  globalPutService,
} from '@/utils/globalApiServices';
import { CspProfilePayload } from './types';

export const createCspProfile = async (data: CspProfilePayload) => {
  const response = await globalPostService('csp/profile', data);
  return response?.ok ? (response.data as CspProfile) : undefined;
};

export const getProfile = async (data = {}): Promise<CspProfile> => {
  const response = await globalGetService('csp/profile', data);
  return response?.ok ? response.data : undefined;
};

export const updateProfileEmail = async (data = {}): Promise<CspProfile> => {
  const response = await globalPutService('csp/profile/email', data);
  return response?.ok ? response.data : undefined;
};
